import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from '@app/_services';
import { CertificationService } from './certification.service';
import { first } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Role } from '@app/_models';

@Component({
  selector: 'app-certification',
  templateUrl: './certification.component.html',
  styleUrls: ['./certification.component.less']
})


export class CertificationComponent implements OnInit {
  readonly DOMAIN_EP = 'com.adobe.relay.data.domain.EndPoint';
  readonly DOMAIN_TC = 'com.adobe.relay.data.domain.TestCase';
  readonly DOMAIN_TS = 'com.adobe.relay.data.domain.TestSuite';
  readonly DOMAIN_MS = 'com.adobe.relay.data.domain.MasterSuite';

  readonly APPROVE = 'APPROVED';
  readonly REJECT = 'REJECTED';

  readonly ADMIN = Role[0].role;
  readonly DEVELOPER = Role[1].role;
  readonly TESTER = Role[2].role;
  readonly VIEWER = Role[3].role;

  moduleDetails: any = {};
  moduleType;
  getCurrentCertifyState: any = null;
  isCertified: boolean = false;
  form: FormGroup;

  reviewComment: string;

  certify: Object = {};
  subjectClass: string;
  operationType: string;

  certifyHistoryList: any = [];
  projectWebAutomationTool:any;

  constructor(private route: ActivatedRoute,
    private AuthService: AuthenticationService,
    private formBuilder: FormBuilder,
    private certificationService: CertificationService,
    private toastr: ToastrService,
    private router: Router) { }

  ngOnInit() {

    this.route.params.subscribe(() => {
      this.moduleType = this.route.snapshot.data['type'];
      this.moduleDetails = this.route.snapshot.data['details'].response;
      this.AuthService.getUserRoleByProject(this.moduleDetails.role); /* Role */
      this.isCertified = this.moduleDetails.certified;
      this.getCertifyOp(this.moduleDetails.project.id, this.moduleDetails.id, 'CERTIFICATION');
      this.getCertifyHistory();

    });

    /* If endpoint page */
    if (this.moduleType === 'ENDPOINT') this.subjectClass = this.DOMAIN_EP;

    /* If testcase page */
    if (this.moduleType === 'TESTCASE') this.subjectClass = this.DOMAIN_TC;

    /* If testsuite page */
    if (this.moduleType === 'TESTSUITE') this.subjectClass = this.DOMAIN_TS;

    /* If mastersuite page */
    if (this.moduleType === 'MASTERSUITE') this.subjectClass = this.DOMAIN_MS;
    this.operationType = 'CERTIFICATION';
    this.setForm();

  }

  setForm() {
    this.form = this.formBuilder.group({
      activeTask: this.formBuilder.group({
        comment: ['', Validators.required]
      }),
      project: this.formBuilder.group({
        id: [this.moduleDetails.project.id, Validators.required]
      }),
      subjectClass: [this.subjectClass],
      operationType:[this.operationType],
      subjectId: [this.moduleDetails.id]
    });
  }
  projectConfigWebTool($event) {
    this.projectWebAutomationTool = $event;
  }

  getCertifyOp(projectId: number, subjectId: number, operationType:string) {
    this.certificationService.getCertifyOp(projectId, subjectId, operationType).pipe(first()).subscribe(data => {
      if (data.code === 200) this.getCurrentCertifyState = data.response;
    });
  }

  getCertifyHistory() {
    this.certificationService.getCertifyHistory(this.moduleDetails.id).pipe(first()).subscribe(data => {
      if (data.code === 200) this.certifyHistoryList = data.response;
    });
  }

  requestCertify() {
    this.certificationService.requestCertify(this.form.value).subscribe(data => {
      if (data.code === 200) {
        this.toastr.success(data.message);
        this.ngOnInit();
      }
    });
  }


  certifyAction(status: string) {

    if (!this.reviewComment || this.reviewComment == '') {
      this.toastr.error('Please enter your comments.');
      return;
    }

    let data = {
      "id": this.getCurrentCertifyState.id,
      "project": {
        "id": this.getCurrentCertifyState.project.id
      },
      "subjectId": this.getCurrentCertifyState.subjectId,
      "subjectClass": this.getCurrentCertifyState.subjectClass,
      "operationState": status,
      "operationType":this.operationType,
      "activeTask": {
        "comment": this.reviewComment
      }
    }

    if (status == null) {
      delete data.operationState;
      this.certificationService.abort(data).subscribe(data => {
        if (data.code === 200) {
          this.toastr.success(data.message);
          this.reviewComment = null;
          this.ngOnInit();
        } else {
          this.toastr.error(data.message);
        }
      });
    } else if (status === this.APPROVE) {
      this.certificationService.approve(data).subscribe(data => {
        if (data.code === 200) {
          this.toastr.success(data.message);
          this.reviewComment = null;
          this.ngOnInit();
        } else {
          this.toastr.error(data.message);
        }
      });
    } else if (status === this.REJECT) {
      this.certificationService.rejected(data).subscribe(data => {
        if (data.code === 200) {
          this.toastr.success(data.message);
          this.reviewComment = null;
          this.ngOnInit();
        } else {
          this.toastr.error(data.message);
        }
      });
    }
  }

}
